module.exports = __webpack_public_path__ + "img/1x.aa84c33.jpg";